<app-infinity-scroll
  [isErrorScroll]="emailsScrollService.isErrorScroll()"
  [isLoadingScroll]="emailsScrollService.isLoadingScroll()"
  [canNavigateForward]="emailsScrollService.canNavigateForward()"
  (loadData)="emailsService.onScroll()"
  (refreshData)="emailsService.loadData(false, false, false)"
  [dataLength]="countTo">
  <div class="mobile-container-cards">
    @if (!countTo) {
      <div class="mt-3 text-center">
        {{ 'noEmailsEmailsContentComponent' | translate }}
      </div>
    }

    @for (
      email of emailsPageStateService.dataSource.data;
      track email.emailId
    ) {
      <div
        [ngClass]="{
          '!font-bold': !email.seen,
        }"
        (contextmenu)="rightClick.emit({ event: $event, email: email })">
        <div class="card">
          <div class="checkbox-col">
            <app-email-select-checkbox [emailId]="email.emailId" />
          </div>

          <mat-card
            class="mobile-row cursor-pointer"
            [ngClass]="{
              'row-select': emailsPageStateService.selection.isSelected(
                email.emailId
              ),
              'row-automatic-reassigned': !!email?.isRowAutoReassigned,
              'row-error': !!email?.isRowWithError,
            }">
            <mat-card-content
              class="mb-0 flex flex-1 flex-col"
              (click)="actionsModals.emailDetails(email)">
              @for (
                column of emailsPageStateService.displayedColumns;
                track column
              ) {
                @switch (column) {
                  @case (EmailColumnsEnum.From) {
                    <div class="card-table-row">
                      <div class="card-table-row-value">
                        {{ email.from | formatSemicolon }}
                      </div>
                    </div>
                  }

                  @case (EmailColumnsEnum.To) {
                    <div class="card-table-row">
                      <div class="card-table-row-value">
                        {{ email.to | formatSemicolon }}
                      </div>
                    </div>
                  }

                  @case (EmailColumnsEnum.Subject) {
                    <div class="card-table-row">
                      <div class="card-table-row-value">
                        {{ email.subject }}
                      </div>
                    </div>
                  }

                  @case (EmailColumnsEnum.Date) {
                    <div class="card-table-row flex-start">
                      <div class="card-table-row-value">
                        {{ email.date | date: 'dd/MM/yyyy HH:mm:ss' }}
                      </div>
                    </div>
                  }

                  @case (EmailColumnsEnum.Date) {
                    <div class="card-table-row flex-start">
                      <div class="card-table-row-value">
                        {{ email.date | date: 'dd/MM/yyyy HH:mm:ss' }}
                      </div>
                    </div>
                  }
                }
              }

              @if (emailsPageStateService.isMailFolderTypeOutbox()) {
                <div class="card-table-row flex-start">
                  {{ 'emailState' + emailStates[email.state] | translate }}
                </div>
              }

              <app-email-tags [tags]="email?.tags" />
              @if (email?.groups?.length) {
                <app-email-group-list [groups]="email.groups" />
              }
            </mat-card-content>

            <div class="icons-mobile-block flex">
              <app-archive-state-cell [email]="email" />

              <app-star-button
                [iconFull]="!!email?.isStarred"
                [showLoading]="!!email?.isStarredLoading"
                (click)="actions.addEmailToStar(email.emailId)" />

              @if (
                !emailsPageStateService.isMailFolderTypeOutbox() &&
                showSendingStateButton
              ) {
                @if (!!email.sendingStatus) {
                  <app-sending-state-button
                    [state]="sendingIcons?.[email.sendingStatus]"
                    (click)="actionsModals.openNotifications(email.emailId)" />
                }
              }

              @for (button of email.actionButtons; track button) {
                @switch (button) {
                  @case (EmailActionsEnum.Reply) {
                    <app-reply-button
                      [showButton]="
                        emailsPageStateService.replyingEmailId() !==
                          email.emailId ||
                        emailsPageStateService.loadingActionFromHeader()
                      "
                      [disabled]="
                        emailsPageStateService.isAnyActionInProgress()
                      "
                      [showLoading]="
                        emailsPageStateService.replyingEmailId() ===
                          email.emailId &&
                        !emailsPageStateService.loadingActionFromHeader()
                      "
                      (click)="buttonActionsService.reply(email)" />
                  }

                  @case (EmailActionsEnum.ReplyAll) {
                    <app-reply-all-button
                      [showButton]="
                        emailsPageStateService.replyingAllEmailId() !==
                          email.emailId ||
                        emailsPageStateService.loadingActionFromHeader()
                      "
                      [disabled]="
                        emailsPageStateService.isAnyActionInProgress()
                      "
                      [showLoading]="
                        emailsPageStateService.replyingAllEmailId() ===
                          email.emailId &&
                        !emailsPageStateService.loadingActionFromHeader()
                      "
                      (click)="buttonActionsService.replyAll(email)" />
                  }
                }
              }
            </div>
          </mat-card>
        </div>
      </div>
    }
  </div>
</app-infinity-scroll>
